module.exports = __webpack_public_path__ + "images/interview-JPMorgan_Chase_and_Co-2.svg";